import { Breakpoints, CTA, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { Close, Edit } from '@volkswagen-onehub/icons-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Booking, Dealer } from '../../modules/entities/Entities';

const StyledBookingRefText = styled(Text)`
  text-wrap: wrap;
  word-break: break-word;
`;

const StyledDescriptionText = styled(Text)`
  text-wrap: wrap;
  word-break: break-word;
`;

const StyledButtonsGroup = styled.div`
  display: flex;

  ${(props) => `column-gap ${props.theme.size.static400};`};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  ${(props) => `row-gap ${props.theme.size.static350};`};
`;

const StyledDescriptionCContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => `row-gap ${props.theme.size.static150};`};
`;

function Description({ title, value }: { title: string; value: string }): ReactElement {
  return (
    <StyledDescriptionCContainer>
      <StyledDescriptionText appearance={TokenTextAppearance.copy100}>{title}</StyledDescriptionText>
      <StyledDescriptionText appearance={TokenTextAppearance.copy200}>{value}</StyledDescriptionText>
    </StyledDescriptionCContainer>
  );
}

const buttonStretch = {
  [Breakpoints.default]: true,
  [Breakpoints.b960]: false,
};

export interface BookingCardProps {
  booking: Booking;
  dealer: Dealer;
  cancelBooking: (booking: Booking) => void;
  amendBooking: (booking: Booking, dealer: Dealer) => void;
}

export function BookingCard({ booking, dealer, cancelBooking, amendBooking }: BookingCardProps): ReactElement {
  const onAmendClick = (): void => {
    amendBooking(booking, dealer);
  };
  const onCancelClick = (): void => {
    cancelBooking(booking);
  };

  return (
    <StyledContainer>
      <div>
        <Text appearance={TokenTextAppearance.copy200}>Number</Text>
        <StyledBookingRefText appearance={TokenTextAppearance.bigcopy100} bold>
          {booking.bookingRef}
        </StyledBookingRefText>
        <Description title="Service" value={booking.serviceType} />
        <Description title="Dealer" value={`${dealer.country} ${dealer.city} ${dealer.address}`} />
        <Description title="Date" value={booking.serviceType} />
      </div>
      <StyledButtonsGroup>
        <CTA tag="button" icon={<Close />} emphasis="secondary" onClick={onCancelClick} stretchContent={buttonStretch}>
          Cancel
        </CTA>
        <CTA tag="button" icon={<Edit />} emphasis="secondary" onClick={onAmendClick} stretchContent={buttonStretch}>
          Amend
        </CTA>
      </StyledButtonsGroup>
    </StyledContainer>
  );
}
